export const checkWebp = new Promise(resolve => {
  const image = new Image();

  image.onload = image.onerror = () => {
    resolve(image.height === 2);
  };
  image.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
});
